import PropTypes from 'prop-types';

function IFHouseholdActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11320)">
                <path
                    d="M12.4702 14.2855C13.3729 13.7797 15.8807 12.6136 15.8807 12.6136C16.001 12.5543 16.1399 12.5453 16.2669 12.5884C16.3938 12.6315 16.4985 12.7232 16.5578 12.8435L17.0594 13.8508C17.1188 13.9717 17.128 14.1112 17.0849 14.2388C17.0419 14.3665 16.95 14.4719 16.8295 14.5321C16.8295 14.5321 14.7857 15.648 13.4147 16.2624L12.4702 14.2855Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.56241 7.4268C4.34504 6.74822 4.33775 6.01979 4.54151 5.337C4.66371 4.80266 4.9102 4.30468 5.26096 3.88348C5.61172 3.46227 6.05687 3.12972 6.56026 2.91283C7.13453 2.62354 7.762 2.45501 8.40394 2.41763C9.04588 2.38025 9.68867 2.47481 10.2926 2.69549C11.6427 3.29735 12.4284 4.78529 13.2184 6.95033C13.332 6.51231 13.5516 6.10897 13.8578 5.77586C14.071 5.54306 14.3514 5.38251 14.66 5.31659C14.9687 5.25066 15.2902 5.28263 15.5798 5.40805C16.4158 5.75496 17.3186 6.66193 16.5662 8.38393C15.8139 10.1059 15.1493 11.1425 15.2329 11.3096L15.9017 12.597L11.5131 14.6533L4.57077 7.44352L4.56241 7.4268Z"
                    fill="#DD3D96"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.816 17.1738C13.816 17.1738 13.164 15.6316 12.2779 13.9305C11.1578 11.7529 10.3177 9.58786 9.84539 8.91495C9.32464 8.20086 8.63547 7.62655 7.83918 7.24311C7.34044 7.01669 6.79508 6.9119 6.24795 6.93733C5.70081 6.96276 5.16752 7.11769 4.69194 7.38939C4.11363 7.66981 3.59944 8.06661 3.18159 8.55494C2.76374 9.04328 2.45121 9.61263 2.26359 10.2273C1.93758 11.6609 2.66483 13.1865 3.91871 15.1049C3.50127 14.9318 3.04797 14.863 2.59796 14.9043C2.28359 14.9329 1.98603 15.059 1.74695 15.2652C1.50787 15.4713 1.33923 15.747 1.26466 16.0537C1.02643 16.9398 1.20615 18.1937 3.03682 18.6409C4.86748 19.0881 6.09628 19.1759 6.17988 19.3514C6.26347 19.527 6.80682 20.6596 6.80682 20.6596L13.816 17.1738Z"
                    fill="#DD3D96"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.74725 22.5778C7.74725 22.5778 11.1745 20.9435 12.4911 20.2205C13.047 19.9153 14.769 19.092 14.769 19.092C14.8888 19.0311 14.9797 18.9253 15.022 18.7978C15.0642 18.6702 15.0544 18.5311 14.9947 18.4107L14.4931 17.3992C14.4331 17.2797 14.3281 17.1889 14.2012 17.1466C14.0743 17.1043 13.9358 17.114 13.816 17.1735C13.816 17.1735 10.3595 18.9624 9.16831 19.4807C8.21955 19.8986 6.7943 20.6593 6.7943 20.6593C6.67376 20.7195 6.58192 20.8249 6.53885 20.9525C6.49578 21.0802 6.50497 21.2197 6.56442 21.3406L7.06598 22.3479C7.12613 22.4684 7.23155 22.5603 7.3592 22.6033C7.48685 22.6464 7.62636 22.6372 7.74725 22.5778V22.5778Z"
                    fill="#DD3D96"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.39091 12.601C8.31568 12.4129 6.25096 10.3942 5.69507 9.67529Z" fill="white" />
                <path
                    d="M8.39091 12.601C8.31568 12.4129 6.25096 10.3942 5.69507 9.67529"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.77235 14.0221C7.77235 14.0221 5.63657 11.5143 4.39105 10.3398Z" fill="white" />
                <path
                    d="M7.77235 14.0221C7.77235 14.0221 5.63657 11.5143 4.39105 10.3398"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8.21118 10.2314C7.56308 11.6019 6.84032 12.9358 6.04614 14.2271Z" fill="white" />
                <path
                    d="M8.21118 10.2314C7.56308 11.6019 6.84032 12.9358 6.04614 14.2271"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.00746 9.4541C6.45455 10.7785 5.7445 12.0316 4.89258 13.1865Z" fill="white" />
                <path
                    d="M7.00746 9.4541C6.45455 10.7785 5.7445 12.0316 4.89258 13.1865"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.71576 14.4905L9.91638 16.0746C9.91638 16.0746 10.5099 19.5687 10.6186 21.6753C10.6687 22.6993 11.1285 25.742 11.1285 25.742C11.1285 25.742 12.0522 27.3219 14.8901 27.7023C16.4277 27.9695 17.9955 28.0159 19.5462 27.8402C21.4361 27.6637 23.2705 27.1048 24.9379 26.1976C26.7351 25.3199 27.0527 23.9531 27.2408 23.6898C27.3746 23.5101 27.3537 21.3409 26.99 18.9418C26.4885 15.7361 26.2335 11.9326 26.2335 11.9326"
                    fill="white"
                />
                <path
                    d="M9.71576 14.4905L9.91638 16.0746C9.91638 16.0746 10.5099 19.5687 10.6186 21.6753C10.6687 22.6993 11.1285 25.742 11.1285 25.742C11.1285 25.742 12.0522 27.3219 14.8901 27.7023C16.4277 27.9695 17.9955 28.0159 19.5462 27.8402C21.4361 27.6637 23.2705 27.1048 24.9379 26.1976C26.7351 25.3199 27.0527 23.9531 27.2408 23.6898C27.3746 23.5101 27.3537 21.3409 26.99 18.9418C26.4885 15.7361 26.2335 11.9326 26.2335 11.9326"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M26.2336 11.9325C26.3465 12.9356 25.4855 13.9512 24.0059 14.7746C22.5263 15.598 20.5117 16.0661 18.2506 16.4464C16.725 16.6775 15.1718 16.6563 13.653 16.3837C11.7304 16.0786 10.2801 15.4099 9.71165 14.4987C9.57521 14.2871 9.48939 14.0468 9.46088 13.7966C9.32295 12.5427 10.6855 11.3682 12.8046 10.4153C14.2787 9.78512 15.8457 9.39971 17.4439 9.27424C18.8335 9.13255 20.2339 9.13255 21.6235 9.27424C24.4197 9.5083 26.0706 10.5699 26.2336 11.9325Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.3957 15.0672C24.0351 14.7997 20.587 13.5291 17.0886 14.085C13.5903 14.6409 12.9299 16.2375 12.9299 16.2375C12.9299 16.2375 15.5714 16.5844 16.5745 16.5969C18.9249 16.5257 21.24 16.0065 23.3957 15.0672V15.0672Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.14454 15.4915L7.20056 15.7086C6.82892 15.7501 6.56128 16.085 6.60277 16.4566L6.65239 16.9011C6.69388 17.2727 7.02879 17.5403 7.40043 17.4989L9.34441 17.2818C9.71605 17.2403 9.98369 16.9054 9.9422 16.5338L9.89258 16.0893C9.85109 15.7177 9.51618 15.4501 9.14454 15.4915Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M29.0378 13.2694L27.0938 13.4864C26.7222 13.5279 26.4545 13.8628 26.496 14.2344L26.5456 14.6789C26.5871 15.0505 26.922 15.3182 27.2937 15.2767L29.2377 15.0597C29.6093 15.0182 29.8769 14.6833 29.8354 14.3116L29.7858 13.8672C29.7443 13.4955 29.4094 13.2279 29.0378 13.2694Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11320">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.176758)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFHouseholdActive;

IFHouseholdActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFHouseholdActive.defaultProps = {
    className: null,
    width: 28,
};
